import { useMemo } from 'react'

import { TIPO_PRODUCTO_VEHICULOS } from '../constants/publicaciones.js'
import {
  deducirTipoDesdeCategoria,
  deducirTipoProducto,
  obtenerReglasPorTipo
} from '../constants/reglasPorTipoPublicacion.js'

const combinarReglas = (reglasTipo, reglasAbono) => ({
  ...reglasTipo,
  conAbonoAlPublicar: reglasTipo.conAbonoAlPublicar || reglasAbono.conAbonoAlPublicar,
  ocultarEan: reglasTipo.ocultarEan || reglasAbono.ocultarEan,
  ocultarPrecioMayorista: reglasTipo.ocultarPrecioMayorista || reglasAbono.ocultarPrecioMayorista,
  ocultarCondicionesDeVenta:
    reglasTipo.ocultarCondicionesDeVenta || reglasAbono.ocultarCondicionesDeVenta,
  ocultarMediosDeEnvio: reglasTipo.ocultarMediosDeEnvio || reglasAbono.ocultarMediosDeEnvio,
  permiteComprar: reglasTipo.permiteComprar && reglasAbono.permiteComprar,
  contactoPorWhatsapp: reglasTipo.contactoPorWhatsapp || reglasAbono.contactoPorWhatsapp
})

/**
 * Cada pantalla deduce el tipo y el hook devuelve el mismo objeto
 * de reglas, ya combinado con las que impone el cobro al publicar.
 * @param {Object} params
 * @param {string|null} [params.tipoProducto]
 * @param {boolean} [params.esScrap]
 * @param {number|null} [params.idCategoriaRaiz]
 * @param {Object|null} [params.publicacion]
 * @param {boolean} [params.conAbonoAlPublicar]
 * @returns {Object} Las reglas que aplican a la publicación.
 */
export const useReglasPublicacion = ({
  tipoProducto,
  esScrap,
  idCategoriaRaiz,
  publicacion,
  conAbonoAlPublicar = false
} = {}) =>
  useMemo(() => {
    const tipo = publicacion
      ? deducirTipoDesdeCategoria(publicacion)
      : deducirTipoProducto({ tipoProducto, esScrap, idCategoriaRaiz })

    const reglasTipo = obtenerReglasPorTipo(tipo)

    if (!conAbonoAlPublicar) {
      return reglasTipo
    }

    return combinarReglas(reglasTipo, obtenerReglasPorTipo(TIPO_PRODUCTO_VEHICULOS))
  }, [tipoProducto, esScrap, idCategoriaRaiz, publicacion, conAbonoAlPublicar])
